export const TwisterActionTypes = {
    SET_TWISTER_LANG: 'SET_TWISTER_LANG_INDEX',
    CLEAR_TWISTER: 'CLEAR_TWISTER',
    SET_TWISTER_LEVEL: 'SET_TWISTER_LEVEL',
    SET_PLAYER_SCORE: 'SET_PLAYER_SCORE',
    SET_TWISTER_INDEX: 'SET_TWISTER_INDEX'
}
